if (typeof TVBrandSelector !== "function") {
  class TVBrandSelector extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const style = document.createElement("style");
      style.textContent = `
        .tv-brand-selector {
          margin-bottom: 10px;
          width: 100%;
          position: relative;
        }
        
        .tv-brand-selector__label {
          display: block;
          padding-bottom: 8px;
          margin-top: 10px;
          font-size: 20px;
          font-weight: 400;
          color: #112e40;
          font-family: tenon, sans-serif;
        }
        
        .tv-dropdown-container {
          position: relative;
          width: 100%;
          max-width: 350px; 
          z-index: 1;
          margin-top: 8px;
        }
        
        .tv-dropdown {
          position: relative;
          width: 68%; 
          font-family: tenon, sans-serif;
        }
        
        /* Default trigger state */
        .tv-dropdown__trigger {
          width: 100%;
          height: 45px;
          padding: 0 15px;
          border-radius: 6px;
          background-color: #fff;
          font-size: 16px;
          text-align: left;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 2px solid transparent;
          position: relative;
        }
        
        /* SELECTED STATE FOR CLOSED DROPDOWN */
        .tv-dropdown__trigger.has-selection {
          background-color: #C6E7DA;
          font-weight: 400;
          border: 2px solid #112e40;
          color: #112e40;
          font-size: 16px;
        }
        
        /* Default "Select" text styling */
        .tv-dropdown__text {
          color: #112e40;
          font-size: 16px;
        }
        
        /* Selected text styling */
        .tv-dropdown__trigger.has-selection .tv-dropdown__text {
          color: #112e40;
          font-size: 16px;
        }
        
        .tv-dropdown__arrow {
          border: solid #333;
          border-width: 0 2px 2px 0;
          display: inline-block;
          padding: 3px;
          transform: rotate(45deg);
        }
        
        .tv-dropdown__panel {
          position: absolute;
          top: 0; /* Position at same spot as trigger */
          left: 0;
          right: 0;
          border: 2px solid #112e40;
          border-radius: 6px;
          background-color: #fff;
          z-index: 5;
          display: none;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .tv-dropdown.active .tv-dropdown__panel {
          display: block;
        }
        
        .tv-dropdown.active .tv-dropdown__trigger {
          visibility: hidden;
        }
        
        .tv-dropdown__option {
          padding: 5px 15px;
          cursor: pointer;
          font-size: 16px;
        }
        
       .tv-dropdown__option:first-child {
          background-color: #f1e6d9;
          margin-top: 10px;
        }
        
        .tv-dropdown__option:last-child {
          margin-bottom: 10px;
        }
        
        .tv-dropdown__option:hover {
          background-color: #f1e6d9;
        }
        
        /* Responsive adjustments to maintain consistent width */
        @media screen and (max-width: 499px) {
          .tv-dropdown-container {
            max-width: 73%; 
          }
        }
      `;
      document.head.appendChild(style);

      this.innerHTML = `
        <div class="product-variant tv-brand-selector">
          <div class="product-variant__name-wrapper">
            <span class="product-variant__name tv-brand-selector__label">Select TV Brand</span>
          </div>
          
          <div class="tv-dropdown-container">
            <div class="tv-dropdown" id="tv-brand-dropdown">
              <!-- Closed state trigger -->
              <button type="button" class="tv-dropdown__trigger">
                <span class="tv-dropdown__text">Select</span>
                <span class="tv-dropdown__arrow"></span>
              </button>
              
              <!-- Open state panel -->
              <div class="tv-dropdown__panel">
                <div class="tv-dropdown__option" data-value="Select">Select</div>
                <div class="tv-dropdown__option" data-value="Samsung">Samsung</div>
                <div class="tv-dropdown__option" data-value="LG">LG</div>
                <div class="tv-dropdown__option" data-value="Sony">Sony</div>
                <div class="tv-dropdown__option" data-value="TCL">TCL</div>
                <div class="tv-dropdown__option" data-value="Hisense">Hisense</div>
                <div class="tv-dropdown__option" data-value="Roku">Roku</div>
                <div class="tv-dropdown__option" data-value="Vizio">Vizio</div>
                <div class="tv-dropdown__option" data-value="Insignia">Insignia</div>
                <div class="tv-dropdown__option" data-value="None of the above" data-property-value="None">None of the above</div>
              </div>
            </div>
          </div>

          <!-- Hidden line item property field -->
          <input type="hidden" name="properties[TV Brand]" id="tv-brand-property">
        </div>
      `;

      // Get elements
      this.dropdown = document.getElementById("tv-brand-dropdown");
      this.trigger = this.dropdown.querySelector(".tv-dropdown__trigger");
      this.selectedText = this.dropdown.querySelector(".tv-dropdown__text");
      this.options = this.dropdown.querySelectorAll(".tv-dropdown__option");
      this.propertyInput = document.getElementById("tv-brand-property");

      // Setup event listeners
      this.trigger.addEventListener("click", (e) => {
        e.stopPropagation();
        this.dropdown.classList.toggle("active");
      });

      this.options.forEach((option) => {
        option.addEventListener("click", this.selectOption.bind(this));
      });

      // Close dropdown when clicking outside
      document.addEventListener("click", (e) => {
        if (!this.dropdown.contains(e.target)) {
          this.dropdown.classList.remove("active");
        }
      });

      // Keyboard accessibility
      this.dropdown.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          if (e.target === this.trigger) {
            this.dropdown.classList.toggle("active");
            e.preventDefault();
          } else if (e.target.classList.contains("tv-dropdown__option")) {
            this.selectOption({ target: e.target });
            e.preventDefault();
          }
        } else if (e.key === "Escape") {
          this.dropdown.classList.remove("active");
          e.preventDefault();
        }
      });
    }

    selectOption(e) {
      const selectedOption = e.target;
      const value = selectedOption.dataset.value;
      const propertyValue = selectedOption.dataset.propertyValue || value;

      // Update selected text
      this.selectedText.textContent = value;

      // Handle "Select" vs actual selection
      if (value !== "Select") {
        // Apply selected styling to the trigger button
        this.trigger.classList.add("has-selection");
        this.propertyInput.value = propertyValue;
      } else {
        // Remove selected styling if "Select" is chosen
        this.trigger.classList.remove("has-selection");
        this.propertyInput.value = "";
      }

      // Close dropdown
      this.dropdown.classList.remove("active");
    }
  }

  if (typeof customElements.get("tv-brand-selector") == "undefined") {
    customElements.define("tv-brand-selector", TVBrandSelector);
  }
}
